export const GIFT_CARD_DOLLAR_PRESETS = [25, 50, 75, 100];
export const GIFT_CARD_HOUR_PRESETS = [1, 2, 3, 4];
function hoursOf(item) {
    if (typeof item.hours === 'number' && item.hours > 0)
        return item.hours;
    const match = item.name.trim().match(/^(\d+)\s*hours?$/i);
    return match ? Number(match[1]) : null;
}
/**
 * Build the "N Hour(s)" gift card presets from the HOURS menu items so they
 * follow Menu Management pricing. Amounts are tax-inclusive
 * (price × (1 + taxRate%)) so the card fully covers that much play time when
 * redeemed — the gift card sale itself is tax-exempt, but the hours it later
 * pays for are taxed. Presets whose menu item is missing/unavailable are omitted.
 */
export function buildHourGiftCardPresets(menu, taxRatePercent, hours = GIFT_CARD_HOUR_PRESETS) {
    const rate = Number.isFinite(taxRatePercent) && taxRatePercent > 0 ? taxRatePercent / 100 : 0;
    const presets = [];
    for (const h of hours) {
        const item = menu.find((m) => m.available && (m.category || '').toUpperCase() === 'HOURS' && hoursOf(m) === h);
        const price = item ? Number(item.price) : NaN;
        if (!item || !Number.isFinite(price) || price <= 0)
            continue;
        presets.push({
            hours: h,
            label: `${h} Hour${h === 1 ? '' : 's'}`,
            amount: Math.round(price * (1 + rate) * 100) / 100,
        });
    }
    return presets;
}
/** Order line name for a gift card sale, noting the hour preset when one was used. */
export function giftCardLineName(amount, hourLabel) {
    return hourLabel
        ? `Gift Card – ${hourLabel} ($${amount.toFixed(2)})`
        : `Gift Card ($${amount.toFixed(2)})`;
}
